import type { Observable as ObservableType } from 'rxjs/Observable';
import fetchJson$ from '@atlassian/jira-fetch/src/utils/as-json-stream.tsx';

export const getUrl = (boardId: number) => `/rest/agile/1.0/board/${boardId}`;

export type BoardDetailsResponse = {
	id: string;
	location?: {
		userAccountId?: string;
		projectKey?: string;
	};
	type: string;
};

export const fetchBoardDetails = (rapidViewId: number): ObservableType<BoardDetailsResponse> =>
	fetchJson$(`${getUrl(rapidViewId)}`);
